// import React, { useState, useEffect } from 'react';
// import '../styles/QuoteModal.css';
// // Import icons from assets
// import callIcon from '../assets/call.webp';
// import whatsappIcon from '../assets/watsapp.png';
// import emailIcon from '../assets/gmail.png';

// const QuoteModal = ({ isOpen, onClose }) => {
//   const [formData, setFormData] = useState({
//     name: '',
//     company: '',
//     email: '',
//     phone: '',
//     city: '',
//     productInterest: '',
//     quantity: '',
//     message: ''
//   });

//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [isSubmitted, setIsSubmitted] = useState(false);

//   const products = [
//     'QuickFit ANC R',
//   ];

//   const quantityOptions = [
//     '10-50 units',
//     '51-100 units',
//     '101-250 units',
//     '251-500 units',
//     '500+ units'
//   ];

//   // Prevent body scroll when modal is open
//   useEffect(() => {
//     if (isOpen) {
//       document.body.style.overflow = 'hidden';
//     } else {
//       document.body.style.overflow = 'auto';
//     }
//     return () => {
//       document.body.style.overflow = 'auto';
//     };
//   }, [isOpen]);

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);
    
//     // Simulate form submission
//     setTimeout(() => {
//       setIsSubmitting(false);
//       setIsSubmitted(true);
//       setFormData({
//         name: '',
//         company: '',
//         email: '',
//         phone: '',
//         city: '',
//         productInterest: '',
//         quantity: '',
//         message: ''
//       });
      
//       setTimeout(() => {
//         setIsSubmitted(false);
//         onClose();
//       }, 3000);
//     }, 1500);
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="quote-modal-overlay" onClick={onClose}>
//       <div className="quote-modal-container" onClick={(e) => e.stopPropagation()}>
        
//         {/* Modal Header */}
//         <div className="quote-modal-header">
//           <div className="quote-modal-header-content">
//             <div className="quote-modal-icon">💰</div>
//             <div>
//               <h2>Request a Quote</h2>
//               <p>Get best B2B pricing for bulk orders</p>
//             </div>
//           </div>
//           <button className="quote-modal-close" onClick={onClose}>
//             ✕
//           </button>
//         </div>

//         {/* Modal Body */}
//         <div className="quote-modal-body">
//           {isSubmitted ? (
//             <div className="quote-modal-success">
//               <div className="quote-modal-success-icon">✓</div>
//               <h3>Quote Request Sent!</h3>
//               <p>Thank you for your interest. Our team will get back to you within 24 hours with the best pricing.</p>
//             </div>
//           ) : (
//             <form onSubmit={handleSubmit} className="quote-modal-form">
//               <div className="quote-modal-row">
//                 <div className="quote-modal-input-group">
//                   <label>Full Name *</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={formData.name}
//                     onChange={handleChange}
//                     required
//                     placeholder="Enter your full name"
//                   />
//                 </div>
//                 <div className="quote-modal-input-group">
//                   <label>Company Name *</label>
//                   <input
//                     type="text"
//                     name="company"
//                     value={formData.company}
//                     onChange={handleChange}
//                     required
//                     placeholder="Enter your company name"
//                   />
//                 </div>
//               </div>

//               <div className="quote-modal-row">
//                 <div className="quote-modal-input-group">
//                   <label>Email Address *</label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     required
//                     placeholder="enter@example.com"
//                   />
//                 </div>
//                 <div className="quote-modal-input-group">
//                   <label>Phone Number *</label>
//                   <input
//                     type="tel"
//                     name="phone"
//                     value={formData.phone}
//                     onChange={handleChange}
//                     required
//                     placeholder="Enter your mobile number"
//                   />
//                 </div>
//               </div>

//               <div className="quote-modal-row">
//                 <div className="quote-modal-input-group">
//                   <label>City</label>
//                   <input
//                     type="text"
//                     name="city"
//                     value={formData.city}
//                     onChange={handleChange}
//                     placeholder="Enter your city"
//                   />
//                 </div>
//                 <div className="quote-modal-input-group">
//                   <label>Product Interest *</label>
//                   <select
//                     name="productInterest"
//                     value={formData.productInterest}
//                     onChange={handleChange}
//                     required
//                   >
//                     <option value="">Select Product</option>
//                     {products.map((product, index) => (
//                       <option key={index} value={product}>{product}</option>
//                     ))}
//                   </select>
//                 </div>
//               </div>

//               <div className="quote-modal-row">
//                 <div className="quote-modal-input-group">
//                   <label>Expected Quantity *</label>
//                   <select
//                     name="quantity"
//                     value={formData.quantity}
//                     onChange={handleChange}
//                     required
//                   >
//                     <option value="">Select Quantity Range</option>
//                     {quantityOptions.map((option, index) => (
//                       <option key={index} value={option}>{option}</option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="quote-modal-input-group">
//                   <label>Custom Branding Required?</label>
//                   <select name="customBranding">
//                     <option value="No">No</option>
//                     <option value="Yes">Yes, Interested</option>
//                   </select>
//                 </div>
//               </div>

//               <div className="quote-modal-input-group full-width">
//                 <label>Message / Requirements</label>
//                 <textarea
//                   name="message"
//                   value={formData.message}
//                   onChange={handleChange}
//                   rows="4"
//                   placeholder="Tell us about your specific requirements..."
//                 ></textarea>
//               </div>

//               <button type="submit" className="quote-modal-submit" disabled={isSubmitting}>
//                 {isSubmitting ? (
//                   <>
//                     <span className="quote-modal-spinner"></span>
//                     Sending...
//                   </>
//                 ) : (
//                   <>
//                     Request Quote
//                     <svg className="quote-modal-submit-icon" viewBox="0 0 24 24" fill="none">
//                       <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
//                     </svg>
//                   </>
//                 )}
//               </button>

//               <p className="quote-modal-note">
//                 * We respect your privacy. Your information is secure with us.
//               </p>
//             </form>
//           )}
//         </div>

//         {/* Quick Contact Options with Asset Icons */}
//         <div className="quote-modal-footer">
//           <div className="quote-modal-footer-divider">
//             <span>Or contact us directly</span>
//           </div>
//           <div className="quote-modal-footer-contacts">
//             <a href="tel:03323240508" className="quote-modal-footer-contact">
//               <img src={callIcon} alt="Call" className="quote-modal-footer-icon" />
//               Call Us
//             </a>
//             <a href="https://wa.me/919748691530" className="quote-modal-footer-contact">
//               <img src={whatsappIcon} alt="WhatsApp" className="quote-modal-footer-icon" />
//               WhatsApp 
//             </a>
//             <a href="mailto:info@paplhear.com" className="quote-modal-footer-contact">
//               <img src={emailIcon} alt="Email" className="quote-modal-footer-icon" />
//               Email
//             </a>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default QuoteModal;


import React, { useState, useEffect } from 'react';
import '../styles/QuoteModal.css';

// Import icons from assets
import callIcon from '../assets/call.webp';
import whatsappIcon from '../assets/watsapp.png';
import emailIcon from '../assets/gmail.png';

const initialFormData = {
  name: '',
  company: '',
  email: '',
  phone: '',
  city: '',
  productInterest: '',
  quantity: '',
  customBranding: 'No',
  message: ''
};

const QuoteModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState(initialFormData);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const whatsappNumber = '919748691530';

  const products = [
    'QuickFit ANC R'
  ];

  const quantityOptions = [
    '10-50 units',
    '51-100 units',
    '101-250 units',
    '251-500 units',
    '500+ units'
  ];

  // Prevent body scrolling while modal is open
  useEffect(() => {
    if (!isOpen) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((previousData) => ({
      ...previousData,
      [name]: value
    }));
  };

  // Send quote request to WhatsApp
  const handleSubmit = (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    setIsSubmitting(true);

    const whatsappMessage = `
*NEW QUOTE REQUEST - PAPL HEAR*

*CUSTOMER DETAILS*
--------------------------
Name: ${formData.name}
Company: ${formData.company}
Email: ${formData.email}
Phone: ${formData.phone}
City: ${formData.city || 'Not Provided'}

*ORDER DETAILS*
--------------------------
Product: ${formData.productInterest}
Expected Quantity: ${formData.quantity}
Custom Branding: ${formData.customBranding}

*MESSAGE / REQUIREMENTS*
--------------------------
${formData.message || 'No additional requirements'}

--------------------------
Submitted via PAPL HEAR Website
    `.trim();

    const whatsappURL =
      `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

    // Open WhatsApp with prefilled customer details
    const whatsappWindow = window.open(
      whatsappURL,
      '_blank'
    );

    if (whatsappWindow) {
      whatsappWindow.opener = null;
    } else {
      // Fallback when browser blocks a new tab
      window.location.href = whatsappURL;
    }

    setIsSubmitting(false);

    // Do not show success or clear the form here.
    // Opening WhatsApp does not confirm message delivery.
  };

  if (!isOpen) return null;

  return (
    <div
      className="quote-modal-overlay"
      onClick={onClose}
    >
      <div
        className="quote-modal-container"
        onClick={(e) => e.stopPropagation()}
      >

        {/* Modal Header */}
        <div className="quote-modal-header">
          <div className="quote-modal-header-content">

            <div className="quote-modal-icon">
              💰
            </div>

            <div>
              <h2>Request a Quote</h2>
              <p>Get best B2B pricing for bulk orders</p>
            </div>

          </div>

          <button
            type="button"
            className="quote-modal-close"
            onClick={onClose}
            aria-label="Close quote modal"
          >
            ✕
          </button>
        </div>

        {/* Modal Body */}
        <div className="quote-modal-body">

          <form
            onSubmit={handleSubmit}
            className="quote-modal-form"
          >

            {/* Name and Company */}
            <div className="quote-modal-row">

              <div className="quote-modal-input-group">
                <label>Full Name *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Enter your full name"
                />
              </div>

              <div className="quote-modal-input-group">
                <label>Company Name *</label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  required
                  placeholder="Enter your company name"
                />
              </div>

            </div>

            {/* Email and Phone */}
            <div className="quote-modal-row">

              <div className="quote-modal-input-group">
                <label>Email Address *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="enter@example.com"
                />
              </div>

              <div className="quote-modal-input-group">
                <label>Phone Number *</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  placeholder="Enter your mobile number"
                />
              </div>

            </div>

            {/* City and Product */}
            <div className="quote-modal-row">

              <div className="quote-modal-input-group">
                <label>City</label>
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  placeholder="Enter your city"
                />
              </div>

              <div className="quote-modal-input-group">
                <label>Product Interest *</label>

                <select
                  name="productInterest"
                  value={formData.productInterest}
                  onChange={handleChange}
                  required
                >
                  <option value="">
                    Select Product
                  </option>

                  {products.map((product, index) => (
                    <option
                      key={index}
                      value={product}
                    >
                      {product}
                    </option>
                  ))}

                </select>
              </div>

            </div>

            {/* Quantity and Branding */}
            <div className="quote-modal-row">

              <div className="quote-modal-input-group">
                <label>Expected Quantity *</label>

                <select
                  name="quantity"
                  value={formData.quantity}
                  onChange={handleChange}
                  required
                >
                  <option value="">
                    Select Quantity Range
                  </option>

                  {quantityOptions.map((option, index) => (
                    <option
                      key={index}
                      value={option}
                    >
                      {option}
                    </option>
                  ))}

                </select>
              </div>

              <div className="quote-modal-input-group">
                <label>Custom Branding Required?</label>

                <select
                  name="customBranding"
                  value={formData.customBranding}
                  onChange={handleChange}
                >
                  <option value="No">
                    No
                  </option>

                  <option value="Yes, Interested">
                    Yes, Interested
                  </option>
                </select>

              </div>

            </div>

            {/* Message */}
            <div className="quote-modal-input-group full-width">

              <label>Message / Requirements</label>

              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="4"
                placeholder="Tell us about your specific requirements..."
              />

            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="quote-modal-submit"
              disabled={isSubmitting}
            >

              {isSubmitting ? (
                <>
                  <span className="quote-modal-spinner"></span>
                  Opening WhatsApp...
                </>
              ) : (
                <>
                  Request Quote

                  <svg
                    className="quote-modal-submit-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M5 12H19M19 12L13 6M19 12L13 18"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </>
              )}

            </button>

            <p className="quote-modal-note">
              * By continuing, your entered details will
              be prepared as a WhatsApp message. You
              must press Send in WhatsApp to submit
              your enquiry.
            </p>

          </form>

        </div>

        {/* Quick Contact Options */}
        <div className="quote-modal-footer">

          <div className="quote-modal-footer-divider">
            <span>Or contact us directly</span>
          </div>

          <div className="quote-modal-footer-contacts">

            {/* Call */}
            <a
              href="tel:03323240508"
              className="quote-modal-footer-contact"
            >
              <img
                src={callIcon}
                alt="Call"
                className="quote-modal-footer-icon"
              />
              Call Us
            </a>

            {/* WhatsApp */}
            <a
              href={`https://wa.me/${whatsappNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              className="quote-modal-footer-contact"
            >
              <img
                src={whatsappIcon}
                alt="WhatsApp"
                className="quote-modal-footer-icon"
              />
              WhatsApp
            </a>

            {/* Email */}
            <a
              href="mailto:info@paplhear.com"
              className="quote-modal-footer-contact"
            >
              <img
                src={emailIcon}
                alt="Email"
                className="quote-modal-footer-icon"
              />
              Email
            </a>

          </div>

        </div>

      </div>
    </div>
  );
};

export default QuoteModal;
